<template>
  <div
    class="text-center">
    <div
      class="custom-file-input d-flex align-center justify-center"
      @dragover.prevent
      @drop="handleDrop"
      @dragenter="handleDragEnter"
      @dragleave="handleDragLeave"
      :style="$refs.FileUploader && !$refs.FileUploader.valid ? 'border: 2px dashed var(--v-error-base);' : ''">
      <v-container
        style="pointer-events: none;">
        <v-row
          no-gutters
          justify="center"
          style="pointer-events: none; width: 100%;">
          <v-col
            :class="{
              'd-none': !hasFile,
              'd-flex align-center justify-center': hasFile,
              'col-6': hasFile && $vuetify.breakpoint.mdAndUp,
              'col-12': $vuetify.breakpoint.smAndDown,
            }">
            <v-file-input
              v-show="hasFile"
              ref="FileUploader"
              :accept="accept"
              chips
              hide-details
              v-model="localFile"
              prepend-icon=""
              append-icon=""
              :clearable="false"
              truncate-length="100"
              class="py-0 px-2 ma-0 transparent"
              color="transparent"
              :rules="$attrs.rules ? $attrs.rules : []"
              style="
                height: 40px;
                width: 300px;
                max-width: 300px;
                overflow: hidden;
              ">
              <template v-slot:selection="{ text }">
                <div
                  class="d-block muted-foreground rounded-pill"
                  style="width: 100%; pointer-events: auto;">
                  <v-sheet
                    close
                    large
                    height="40"
                    max-width="100%"
                    :class="{
                      'onTransition success rounded-pill foreground--text d-flex align-center pa-1 flex-wrap': true,
                    }"
                    :style="{ width: onProgressWidth }">
                    <v-row
                      v-show="!isLoadingFile"
                      class="d-flex align-center"
                      style="width: 100%;"
                      no-gutters>
                      <v-col
                        class="text-truncate font-weight-regular pl-4 pr-2"
                        style="
                          font-size: 16px;
                          width: 100%;
                          max-width: 250px;
                        ">
                        {{ text }}
                      </v-col>

                      <v-col
                        style="max-width: 34px;">
                        <v-btn
                          icon
                          :class="isLoadingFile
                            ? 'v-btn.v-btn--disabled v-btn--has-bg'
                            : defaultColor"
                          color="muted"
                          v-if="progressWidth > 10"
                          :disabled="isLoadingFile"
                          style="pointer-events: auto;"
                          @click.stop="removeFile"
                          height="32"
                          width="32">
                          <v-icon
                            size="20">
                            far fa-trash-alt
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </div>
              </template>
            </v-file-input>
          </v-col>

          <v-col
            :class="{
              'col-8': !hasFile && $vuetify.breakpoint.mdAndUp,
              'col-6': hasFile && $vuetify.breakpoint.mdAndUp,
              'col-12': $vuetify.breakpoint.smAndDown,
            }">
            <v-container
              fluid>
              <v-row
                justify="center">
                <v-col
                  :class="{
                    'd-flex align-center': true,
                    'justify-end': !isHandleDragEnter,
                    'justify-center': isHandleDragEnter,
                    'col-12 justify-center': $vuetify.breakpoint.smAndDown,
                  }"
                  :style="`
                    pointer-events: none;
                    ${
                      $vuetify.breakpoint.lgAndUp
                        ? hasFile ? 'max-width: 33%' : 'width: 48%;'
                      : hasFile ? 'max-width: 32%;' : ''
                    }
                  `">
                  <div
                    class="d-flex flex-column justify-center"
                    style="pointer-events: none;">
                    <v-img
                      src="icons/uploadIcon.svg"
                      style="max-height: 35px;"
                      contain
                    />

                    <label
                      class="foreground--text text-center"
                      style="font-size: 16px;">
                      {{ uploadMessage }}
                    </label>
                  </div>
                </v-col>

                <v-col
                  :class="{
                    'd-flex align-center justify-center': true,
                    'col-12 py-0': $vuetify.breakpoint.smAndDown,
                  }"
                  :style="
                    $vuetify.breakpoint.mdAndUp
                      ? 'max-width: 4%;'
                      : 'height: 60px;'"
                  v-if="!isHandleDragEnter">
                  <h2
                    :class="{
                      'dashLineVertical': true,
                    }">
                    <span
                      class="muted px-3 muted-background--text"
                      style="position: absolute; font-size: 14px">
                      Ou
                    </span>
                  </h2>
                </v-col>

                <v-col
                  :class="{
                    'd-flex align-center justify-start': true,
                    'justify-start': $vuetify.breakpoint.mdAndUp,
                    'col-12 justify-center': $vuetify.breakpoint.smAndDown,
                  }"
                  style="width: 48%;"
                  v-if="!isHandleDragEnter">
                  <v-btn
                    :color="defaultColor"
                    class="elevation-2"
                    style="pointer-events: auto;"
                    :disabled="isLoadingFile"
                    :style="`${
                      $vuetify.breakpoint.lgAndUp
                        ? hasFile
                          ? btnUpload.autoWidthStyle
                          : btnUpload.style
                        : btnUpload.autoWidthStyle
                      }; pointer-events: auto;`"
                    @click="openFileFolder">
                    Carregar arquivos
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <span
      class="error--text">
      {{ errorMessages }}
    </span>
  </div>
</template>
<script>
import Formatters from '@/shared/formatters/formatters';
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';

export default {
  name: "FileUploader",

  data: () => ({
    formatter: null,
    defaultClassColumn: 'py-0',
    uploadMessage: 'Arraste aqui',
    isHandleDragEnter: false,
    localFile: null,
    fileUploaderReady: true,
    isLoadingFile: false,
    loaderHandling: false,
    progressWidth: 0,
  }),

  props: {
    file: {
      type: [File, null]
    },

    accept: {
      type: String,
      default: ".xls,.xlsx,.csv,.txt,.pdf,.png,.jpg,.jpeg,.bmp,.tiff,.webp",
    },

    fileLoaded: {
      type: Boolean,
      default: false,
    },

    defaultColor: {
      type: String,
      default: 'primary',
    }
  },

  watch: {
    file: {
      deep: true,
      handler(file)  {
        this.localFile = file;
      }
    },

    localFile(file) {
      if (file) {
        this.progressWidth = 0;
        this.isLoadingFile = true;
        this.$emit('isLoadingFile', true);

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.progressWidth = 90;
          })
        });

        setTimeout(() => {
          this.$emit('setFile', file);
        }, 2000);
      }
    },

    isLoadingFile(newLoadValue, oldLoadValue) {
      if (oldLoadValue && !newLoadValue) {
        this.loaderHandling = true;

        requestAnimationFrame(() => {
          this.progressWidth = 100;
        })
        return;
      }

      if (newLoadValue) {
        this.progressWidth = 0;
      }
    },

    fileLoaded(fileLoaded) {
      if (fileLoaded) {
        this.isLoadingFile = false;
        this.$emit('isLoadingFile', false);

        this.$emit('loadedFinished');
      }
    }
  },

  mixins: [
    MajorityMixin,
  ],

  methods: {
    openFileFolder() {
      this.$refs.FileUploader.$refs.input.click();
    },
    removeFile() {
      this.localFile = null;

      this.$emit('clean');
    },
    async handleDrop(event) {
      if (event && event.dataTransfer && event.dataTransfer.files) {
        this.localFile = null;

        const files = Array.from(event.dataTransfer.files);
        this.localFile = files[0];
        event.preventDefault();
        this.handleDragLeave();
      }
    },
    handleDragEnter(event) {
      event.preventDefault();
      this.uploadMessage = 'Solte os arquivos aqui';
      this.isHandleDragEnter = true;
    },
    handleDragLeave() {
      this.uploadMessage = 'Arraste aqui';
      this.isHandleDragEnter = false;
    },
  },

  computed: {
    hasFile() {
      return this.localFile instanceof File && this.localFile.size > 0
    },
    fileUploaderRef() {
      if (!this.fileUploaderReady || !this.$refs.FileUploader) return false;

      return this.$refs.FileUploader;
    },
    errorMessages() {
      const ref = this.fileUploaderRef;
      if (!ref || !Array.isArray(ref.errorBucket)) return '';

      return ref.errorBucket
        .filter((msg) => typeof msg === 'string' && msg.trim().length > 0)
        .join('\n');
    },
    onProgressWidth() {
      return `${this.progressWidth}%`;
    },
  },

  created() {
    this.fileUploaderReady = false;
  },

  mounted() {
    this.formatter = new Formatters();

    this.$nextTick(() => {
      if (this.$refs.FileUploader) {
        this.fileUploaderReady = true;
      }
    });
  },
}
</script>
<style scoped>
.custom-file-input {
  height: 100%;
  width: 100%;
  border: 2px dashed var(--v-border-base);
  border-radius: 20px;
  position: relative;
}
.dashLine {
  width: 300px;
  text-align: center;
  border-bottom: 1px solid var(--v-border-base);
  line-height: 0.1em;
  margin: 10px 0 20px;
}

.dashLineVertical {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
  position: relative;
}

.dashLineVertical::before {
  content: '';
  border-left: 1px solid var(--v-border-base);
  height: 100%;
}

.onTransition {
  transition: width 1.5s ease-out;
}
</style>
